import { Grid, Paper, Skeleton, Box } from "@mui/material";

export const SecurityPipelineGithubStatsSkeleton = () => {
  return (
    <Grid container spacing={2} width="100%">
      {Array.from({ length: 3 }).map((_, index) => (
        <Grid key={index} size={{ xs: 12, md: 4, lg: 4 }}>
          <Paper
            sx={{
              position: "relative",
              py: 2,
              px: 3,
              borderRadius: 1.5,
            }}
          >
            {/* Badge skeleton (only for third item) */}
            {index === 2 && (
              <Box
                sx={{
                  position: "absolute",
                  top: "4px",
                  right: "4px",
                  borderRadius: "4px",
                }}
              >
                <Skeleton
                  variant="rounded"
                  width={60}
                  height={20}
                  animation="wave"
                />
              </Box>
            )}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignSelf: "stretch",
              }}
            >
              <Skeleton
                variant="text"
                width="60%"
                height={48}
                animation="wave"
                sx={{ mb: 1 }}
              />
              <Skeleton
                variant="text"
                width="40%"
                height={20}
                animation="wave"
              />
            </Box>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};
